module.exports = __webpack_public_path__ + "static/media/Volume.957faba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/VolumeModal/Volume.png
// module id = 449
// module chunks = 0